import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UserService } from 'src/app/services/user.service';
import { Router, Event, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  ForgotPasswordForm = new UntypedFormGroup({
    EmailId: new UntypedFormControl('')
  });

  orgCode: string;
  currentRoute: string;

  constructor(
    private route: ActivatedRoute,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private userService: UserService,
    private router: Router,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
  ) {
    // this.orgCode = route.snapshot.params['code'];
    // this.route.params.subscribe(params => {
    //   this.orgCode = params['id'];
    // });

    this.orgCode = this.router.url.split('/')[1];
  }


  ngOnInit() {
  }

 
  Submit() {
    if (this.validateControls()) {
      this.modalRef.dismiss();
      var obj = new Object();
      obj['Email'] = this.ForgotPasswordForm.value.EmailId;
      obj['OrgCode'] = this.orgCode;
      this.summaryService.forgotPassword('api/appuser/forgotpassword',obj).subscribe(result => {
        // if (result.Status === true) {
        //   const modalRef = this.modalService.open(MessageBoxComponent, {
        //     backdrop: false,
        //     keyboard: false
        //   });
        //   modalRef.componentInstance.Content={ 
        //     heading: 'Validation Message(s)', 
        //     content: { 
        //       heading: '', 
        //       description: result.errMessage 
        //     } 
        //   } 
        //   modalRef.result.then(result1 => {
        //     if (this.orgCode !== null && this.orgCode !== "undefined" && this.orgCode !== '')
        //         this.redirectTo(this.orgCode + '/login');
        //   });
        // }

        if(result.Status === true)
          {
            this.commonService.SuccessBanner(result.errMessage);
            if (this.orgCode !== null && this.orgCode !== "undefined" && this.orgCode !== '')
                       this.redirectTo(this.orgCode + '/login');
          }
          
        else {
          const modalRef = this.modalService.open(MessageBoxComponent, { 
            backdrop: false,
            keyboard: false
          });
          modalRef.componentInstance.Content={ 
            heading: 'Validation Message(s)', 
            content: { heading: '', 
            description: result.errMessage 
            } 
          } 
          modalRef.result.then(result1 => {
            if (this.orgCode !== null && this.orgCode !== "undefined" && this.orgCode !== '')
                this.redirectTo(this.orgCode + '/login');
          });
        }
      });
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ForgotPasswordForm.value;

    if (formData.EmailId === null || formData.EmailId === "" || formData.EmailId === undefined) {
      $("#email").addClass("ng-touched ng-invalid validate-error");
      $("#email").removeClass("ng-untouched ng-valid");
      message += "Please enter Email<br/>";
      isValid = false;
    }
    else if(formData.EmailId !== null || formData.EmailId !== "" || formData.EmailId !== undefined){
      if(formData.EmailId.length > 100){
        message += "Length of Email should not exceed 100<br/>";
      }
      else {
        const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (formData.EmailId.match(mailformat)) {
          $("#email").addClass("ng-untouched ng-valid");
          $("#email").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#email").addClass("ng-touched ng-invalid validate-error");
          $("#email").removeClass("ng-untouched ng-valid");
          message += "Please enter Valid Email<br/>";
          isValid = false;
        }
      }
    } 
  
    if (!isValid)
    this.commonService.ValidationBanner(message);
    return isValid;
  }

  Cancel() {
    this.modalRef.dismiss();
    // let orgCode = this.userService.getOrgCode();
    if (this.orgCode !== null && this.orgCode !== "undefined" && this.orgCode !== '')
      this.redirectTo(this.orgCode + '/login');
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
}
